import * as React from 'react';
import { bindCallback } from 'rxjs/observable/bindCallback';


const CREFooter = (props) => (
    <div className="floating-footer-button">
        <a href="/ContactUs" className="footer-contact-btn">
            <span className="text-nowrap" style={{color: "black"}} >Contact Us</span>
        </a>
    </div>
);

export default () => <CREFooter />;



// WEBPACK FOOTER //
// ./src/pages/CREFooter.tsx